/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {OrderProduct} from './OrderProduct';
import {OrderStatus} from './OrderStatus';
import {PaymentMethod} from './PaymentMethod';
import {DeliveryMethod} from './DeliveryMethod';
import {OrderDocument} from './OrderDocument';

export interface Order {
  id: number;
  syncUid: string;
  number1C: string;
  invoiceNumber: string;
  invoiceCost: number;
  documents: OrderDocument[];
  comment: string;
  createdAt: Date;
  updatedAt: Date;
  reservedAt: Date;
  totalCost: number;
  totalPaid: number;
  positions: number;
  orderStatus?: OrderStatus;
  paymentMethod?: PaymentMethod;
  deliveryMethod?: DeliveryMethod;
  deliveryAddress?: string;
  company?: string;
  contract?: string;
  products?: OrderProduct[];
  orderStates?: OrderStatus[];
  orderIp: string;
  promoCode?: string;
}
